import { render, staticRenderFns } from "./xltpSet.vue?vue&type=template&id=a2fa0222&scoped=true&"
import script from "./xltpSet.vue?vue&type=script&lang=js&"
export * from "./xltpSet.vue?vue&type=script&lang=js&"
import style0 from "./xltpSet.vue?vue&type=style&index=0&id=a2fa0222&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fa0222",
  null
  
)

export default component.exports